<div class="tt-input__container col-xs-12 sp-0">
    <fieldset style="display: contents">
        <grid class="tt-input__base col-xs-12 sp-0" [ngClass]="class['base']">
            <legend class="tt-input__label" [ngStyle]="style['label']" (click)="openTranslateDialog($event)">
                {{ label }}
                <span *ngIf="helptextTranslated" tabindex="0" class="far fa-question-circle tt-input__toggletip" [ttPopover]="tip" ttPopoverBackgroundColor="#323232"></span>
                <span *ngIf="ttRequired === true" class="tt-input__label--required">*</span>
            </legend>

            <span
                [hidden]="!sublabel || sublabel === ttLabel + '_sublabel'"
                *ngIf="sublabel && (!ttInvalid || !ttInvalidText)"
                class="tt-input__sublabel"
                [ngClass]="class['sublabel']"
                [ngStyle]="style['sublabel']"
            >
                {{ sublabel }}
            </span>
            <!-- <span *ngIf="ttInvalidText && ttInvalid" class="tt-input__invalidtext" [ngClass]="class['invalidtext']" [ngStyle]="style['invalidtext']">
            {{ translations["invalidtext"] }}
        </span> -->
            <div #groupRef class="tt_input__input-group tt-radio-button-group__input-group">
                <ng-content />
            </div>
        </grid>
    </fieldset>
</div>

<ng-template #tip>
    <span class="tt-input__toggletip-text">{{ toggleTipText }}</span>
</ng-template>
